


































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, UploadDocumentRequest } from '@/types/request';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { CommonUtils } from '@/util/commonUtils';
import { ApiResponse, UploadFileResponse } from '@/types/response';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            documentName: '',
            document: {
                file: FormData,
                filename: '',
            },
        };
    },
    validations: {
        documentName: {
            required,
        },
    },
})
export default class UploadDocumentsModal extends Vue {
    private show = true;
    private showDeleteConfirmBox = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();

    private mounted() {
        this.$data.documentName = this.$route.query.doc;
    }

    private async setDocument($event: any) {
        const filename = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
            filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            if (this.$route.query.doc === 'Certificate of Insurance' && !filename.endsWith('.pdf')) {
                const toastEvent: ToastEvent = {
                    message: 'File type should be PDF only',
                    title: 'Invalid file format.',
                    varient: 'danger',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.removeDocument();
            } else {
                this.$data.document.file = $event.target.files[0];
                this.$data.document.filename = $event.target.files[0].name;
            }
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = 'file-input';
            const element = this.$refs[inputName] as any;
            element.reset();
        }
    }
    private async removeDocument() {
        this.$data.document.file = undefined;
        this.$data.document.filename = '';
        this.showDeleteConfirmBox = false;
        const inputName = 'file-input';
        const element = this.$refs[inputName] as any;
        element.reset();
    }
    private async uploadFile(file: FormData, baseUrl: string): Promise<ApiResponse<UploadFileResponse>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: file,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<UploadFileResponse>(apiRequest);
        if (response.success && response.data) {
            return response;
        } else {
            CommonUtils.showError(response);
            throw new Error(JSON.stringify(response));
        }
    }
    private async uploadDocuments() {
        const formData = new FormData();
        const transporterId = this.$route.params.id;
        formData.append('file', this.$data.document.file);
        const uploadResponse = await this.uploadFile(formData, this.$store.state.serverUrl);
        if (uploadResponse.data) {
            const iHttpService = ObjectFactory.getHttpService();
            const uploadDocumentRequest: UploadDocumentRequest = {
                name: this.$data.documentName,
                resourceId: uploadResponse.data.fileName,
                filename: this.$data.document.filename,
            };
            if (this.sessionInfo.scopes.includes('transporter')) {
                const apiRequest: ApiRequest = {
                    baseURL: this.$store.state.serverUrl,
                    url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/${transporterId}/document`,
                    data: uploadDocumentRequest,
                    loaderEvent: {
                        show: true,
                    },
                };
                const response = await iHttpService.put<any>(apiRequest);
                if (response.success) {
                    const toastEvent: ToastEvent = {
                        message: 'Document have been uploaded.',
                        title: 'Success!',
                        varient: 'success',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                    this.$emit('success');
                    this.close();
                } else {
                    CommonUtils.showError(response);
                }
            }
            if (this.sessionInfo.scopes.includes('driver')) {
                const apiRequest: ApiRequest = {
                    baseURL: this.$store.state.serverUrl,
                    url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/${transporterId}/document`,
                    data: uploadDocumentRequest,
                    loaderEvent: {
                        show: true,
                    },
                };
                const response = await iHttpService.put<any>(apiRequest);
                if (response.success) {
                    const toastEvent: ToastEvent = {
                        message: 'Document have been uploaded.',
                        title: 'Success!',
                        varient: 'success',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                    this.$emit('success');
                    this.close();
                } else {
                    CommonUtils.showError(response);
                }
            }
        }
    }
    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }
}
